import { DefaultTheme } from 'styled-components';

export const defaultTheme: DefaultTheme = {
  name: 'default',
  isWebView: false,
  tabBarHeight: 60,
  insetsBottom: 0,
  palette: {
    primary: {
      background: '#fff',
      border: '#f1f3f7',
      labels: '#212c3a',
    },
    secondary: {
      background: '#f6f7fa',
      border: '#eaebf2',
      labels: '#8d94ad',
    },
    tertiary: {
      background: '#fff5f1',
      labels: '#b1b8c6',
    },
    quartenary: {
      background: '#fafbfb',
      labels: '#575d78',
    },
    system: {
      deepBlue: '#4264fd',
      blue: '#4c88f9',
      lightBlue: '#dae8ff',
      deepGreen: '#32914e',
      darkGray: '#1A1A1A',
      green: '#3db460',
      red: '#ff586d',
      redLight: '#FDECF4',
      yellow: '#ffb900',
      lightYellow: '#FFF9E8',
      white: '#fff',
      'white-20': 'rgba(255, 255, 255, 0.2)',
      blueToWhite: '#4c88f9',
      mediumLightBlue: '#6598fc',
      lightBackground: '#fafbfb',
      redToWhite: '#fdecf4',
      'black-50': 'rgba(7, 7, 7, 0.5)',
      'black-65': 'rgba(7, 7, 7, 0.65)',
      'black-80': 'rgba(7, 7, 7, 0.8)',
      scrollbar: '#b0b0b0',
      deepOrange: '#e04304',
    },
    brand: {
      main: '#ff4f08',
      mainOnHover: '#e64301',
      vip1: '#ff3d00',
      vip2: '#ff7a45',
      vipGradient:
        'linear-gradient(90deg, #FDE4EC 0%, #FCC0AC 50%, #F9A890 100%)',
      premium1: '#ff9f2b',
      premium2: '#8c9eff',
      premiumGradient:
        'linear-gradient(90deg, #FFEFD0 0%, #F2EEFF 60%, #EDE8FF 100%)',
      green: '#77c81d',
    },
    package: {
      basis: '#696969',
    },
    overlay: {
      8: 'rgba(0, 0, 0, 0.08)',
      20: 'rgba(0, 0, 0, 0.2)',
      40: 'rgba(0, 0, 0, 0.4)',
      50: 'rgba(0, 0, 0, 0.5)',
      60: 'rgba(0, 0, 0, 0.6)',
    },
    gradient: {
      main: 'linear-gradient(135deg, #fe5722 0%, #fe5631 52.91%, #fe5449 83.29%, #fe6168 100%)',
    },
  },
  breakpoints: {
    xsm: '374px',
    sm: '743px',
    md: '949px',
    lg: '1359px',
    xl: '1439px',
  },
};
